const ClaimUpdatesHero = () => {
  return (
    <div className="bg-foreground py-10 sm:py-12">
      <div className="container mx-auto max-w-6xl px-4">
        <h1 className="mb-3 text-4xl font-black text-white sm:text-5xl">
          Car Finance Claim Updates
        </h1>
        <p className="max-w-2xl text-base leading-relaxed text-white/85 sm:text-lg">
          Keeping you informed about your claim and the latest developments
          affecting car finance compensation.
        </p>
      </div>
    </div>
  )
}

export default ClaimUpdatesHero
